/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { SET_VISIBILITY_STATE } from './visibilityevents.types';
import { VisibilityState } from './visibilitystate';

export const setAppVisibilityStateAction = (visibilityState: VisibilityState): AnyAction => ({
    type: SET_VISIBILITY_STATE,
    payload: {
        visibilityState,
    },
});
